import React from "react";

function Policy() {
  return (
    <div class="  bg-white shadow-md  xl:px-36 lg:px-24 md:px-16 px-10    py-14">
      <h1 class="text-3xl font-semibold mb-6">Privacy Policy</h1>
      <p class="mb-6">
        At Keyline Solution, we value your privacy and are committed to
        protecting your personal information. This Privacy Policy outlines how
        we collect, use, disclose, and safeguard your information when you visit
        our website{" "}
        <a href="www.keylinesolution.com" class="text-blue-500">
          www.keylinesolution.com
        </a>
        . By accessing or using our website, you consent to the practices
        described in this Privacy Policy.
      </p>

      <h2 class="text-2xl font-semibold mb-4">Information We Collect</h2>
      <p class="mb-6">
        We may collect both personally identifiable information (PII) and
        non-personally identifiable information (non-PII) from you when you
        interact with our website. The types of information we collect may
        include:
      </p>

      <ul class="list-disc ml-8 mb-6">
        <li>
          Personal Information: This may include your name, email address, phone
          number, and any other information you voluntarily provide through
          forms or email communication.
        </li>
        <li>
          Usage Information: We may collect non-PII about your interactions with
          our website. This includes your IP address, browser type, device type,
          operating system, and pages visited.
        </li>
      </ul>

      <h2 class="text-2xl font-semibold mb-4">How We Use Your Information</h2>
      <p class="mb-6">
        We may use the information we collect for the following purposes:
      </p>

      <ul class="list-disc ml-8 mb-6">
        <li>
          To Provide Services: We may use your personal information to respond
          to your inquiries, provide you with information or services you
          request, and to fulfill any other purpose for which you provide it.
        </li>
        <li>
          To Improve Our Website: We use non-PII to analyze how visitors use our
          website and to make improvements to its content and functionality.
        </li>
        <li>
          To Send Emails: If you provide your email address, we may use it to
          send you information and updates related to our products and services.
          You can opt-out of receiving promotional emails at any time.
        </li>
      </ul>

      <h2 class="text-2xl font-semibold mb-4">
        Disclosure of Your Information
      </h2>
      <p class="mb-6">
        We may share your information in the following circumstances:
      </p>

      <ul class="list-disc ml-8 mb-6">
        <li>
          Service Providers: We may share your information with third-party
          service providers who assist us in operating our website or conducting
          our business. These service providers are obligated to keep your
          information confidential.
        </li>
        <li>
          Legal Compliance: We may disclose your information if required by law,
          in response to a subpoena, court order, or government request, or when
          we believe disclosure is necessary to protect our rights, privacy,
          safety, or property.
        </li>
      </ul>

      <h2 class="text-2xl font-semibold mb-4">Data Security</h2>
      <p class="mb-6">
        We take reasonable steps to protect your information from unauthorized
        access, disclosure, alteration, or destruction. However, please be aware
        that no method of data transmission over the Internet or electronic
        storage is completely secure, and we cannot guarantee the absolute
        security of your information.
      </p>

      <h2 class="text-2xl font-semibold mb-4">Third-Party Links</h2>
      <p class="mb-6">
        Our website may contain links to third-party websites. These third-party
        sites have their own privacy policies, and we are not responsible for
        their practices. We encourage you to review the privacy policies of
        these websites.
      </p>

      <h2 class="text-2xl font-semibold mb-4">Children's Privacy</h2>
      <p class="mb-6">
        Our website is not intended for children under the age of 13. We do not
        knowingly collect or solicit personal information from children under
        13. If you believe that we have inadvertently collected information from
        a child under 13, please contact us, and we will take appropriate steps
        to remove such information from our records.
      </p>

      <h2 class="text-2xl font-semibold mb-4">
        Changes to this Privacy Policy
      </h2>
      <p class="mb-6">
        We may update this Privacy Policy from time to time to reflect changes
        in our practices or for other operational, legal, or regulatory reasons.
        We will post the updated Privacy Policy on our website with the
        effective date of the changes.
      </p>

      <h2 class="text-2xl font-semibold mb-4">Contact Us</h2>
      <p>
        If you have any questions or concerns about this Privacy Policy or our
        data practices, please contact us using the following information:
      </p>
      <p class="mt-2">Keyline Solution</p>
      <p class="mt-2">
        Website:{" "}
        <a href="www.keylinesolution.com" class="text-blue-500">
          www.keylinesolution.com
        </a>
      </p>
      <p class="mt-2">Phone: +92 333 448 7714</p>
      <p class="mt-2">
        Email:{" "}
        <a href="mailto:ahsan@keylinesolution.com" class="text-blue-500">
          ahsan@keylinesolution.com
        </a>
      </p>

      <p class="mt-8">
        By using our website, you agree to the terms of this Privacy Policy.
      </p>
    </div>
  );
}

export default Policy;
